import { Box, IconButton, useColorModeValue } from "@chakra-ui/react";

export default function WarButton({ showWar, setShowWar }) {
  const iconColor = useColorModeValue("#4b635e", "#E9A6A6");
  const icon = (
    <Box color={iconColor} fontSize="xl">
      ♥
    </Box>
  );

  return (
    <IconButton
      aria-label="Show Sunset Angle"
      icon={icon}
      onClick={() => setShowWar(!showWar)}
      size="md"
      boxShadow="lg"
    />
  );
}
